export default __webpack_public_path__ + "static/media/default-post-image.dd982f18.jpg";